import {appFetch, AppFetchResponse} from "../utils/appFetch";
import {ManagerFormValuesProps} from "../components/shopManagers/NewShopManagerModal";
import {BlackoutDateProps} from "../types/BlackoutPeriod";

export const createBlackoutPeriod = async (domain: string, blackoutPeriodData: BlackoutDateProps): Promise<AppFetchResponse> => {
    return appFetch({
        endpoint: `blackout-period`,
        method: 'POST',
        params: blackoutPeriodData,
        headers: {
            "Content-Type": "application/json",
        },
        domain,
    });
}